import { createApi } from "@reduxjs/toolkit/query/react";

// import { API_URL } from "../../Constans/URL";
import customBaseQuery from "../baseQuery";
// const BASE_URL = API_URL;

const companyDetailsGraphAPI = createApi({
  reducerPath: "companyDetailsGraphAPI",
  baseQuery: customBaseQuery,
  endpoints: (builder) => ({
    getCompanyDetails: builder.query({
      query: () => ({
        url: "companyDetails",
        method: "GET",
      }),
    }),
  }),
});

export const { useGetCompanyDetailsQuery } = companyDetailsGraphAPI;

export default companyDetailsGraphAPI;
